const toggleSideBar = ({ commit }, payload) => {
  commit('SET_SHOW_DRAWER', payload);
};

export default toggleSideBar;
